import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useCheckoutContext } from "@magento/peregrine/lib/context/checkout";
import defaultClasses from "./footerNav.module.scss";
import { useLocation } from "@magento/venia-ui/lib/drivers";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { FooterNavTab } from "./footerNavTab";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import { env } from "build/env";
import useStores from "@Src_main/utils/useStores";
const FooterNav = () => {
  var _location$state;
  const {
    formatMessage
  } = useIntl();
  const [{
    tableData
  }] = useCheckoutContext();
  const [{
    footer_nav
  }, {
    setFooterVisible
  }] = useAppContext();
  const [{
    isSignedIn
  }] = useUserContext();
  const {
    isMobile
  } = useWindowSize();
  const location = useLocation();
  const {
    store_view_code
  } = env;
  const {
    isTableMapLoaded,
    tableDescription
  } = useStores();
  const homeLocation = formatMessage({
    id: "url.key.home"
  });
  const appHomeLocation = formatMessage({
    id: "url.key.app.home"
  });
  const loyaltyLocation = formatMessage({
    id: "url.key.login"
  });
  const preLoginLocation = formatMessage({
    id: "url.key.pre.login"
  });
  const appLoginLocation = formatMessage({
    id: "url.key.app.login"
  });
  const myAreaLocation = formatMessage({
    id: "url.key.myaccount"
  });
  const orderLocation = formatMessage({
    id: "url.key.order"
  });
  const payLocation = formatMessage({
    id: "url.key.pay"
  });
  const bookLocation = formatMessage({
    id: "url.key.book.a.table"
  });
  const bookingDataLocation = formatMessage({
    id: "url.key.book.a.table.reservation"
  });
  const bookEventLocation = formatMessage({
    id: "url.key.book.event"
  });
  const bookEditLocation = formatMessage({
    id: "url.key.book.a.table.edit"
  });
  const menuLocation = "/?cps=".concat(tableData.cps, "&cpt=").concat(tableData.cpt, "&sales_type=").concat(tableData.sales_type);
  const checkoutLocation = formatMessage({
    id: "url.key.checkout"
  });
  const signupLocation = formatMessage({
    id: "url.key.signup"
  });
  const userDataLocation = formatMessage({
    id: "url.key.loyalty.data"
  });
  const receiptLocation = "/receipt";
  const eventsLocation = formatMessage({
    id: "url.key.events"
  });
  const eventsDetailsLocation = formatMessage({
    id: "url.key.events.details"
  });
  const pswRecoveryLocation = formatMessage({
    id: "url.key.psw.recovery"
  });
  const kioskLoginLocation = formatMessage({
    id: "url.key.kiosk.login"
  });
  const appHomeLocationActive = location.pathname.includes(appHomeLocation);
  const myAreaLocationActive = location.pathname.includes(myAreaLocation);
  const orderLocationActive = location.pathname.includes(orderLocation);
  const payLocationActive = location.pathname.includes(payLocation);
  const bookLocationActive = location.pathname.includes(bookLocation);
  const eventsLocationActive = location.pathname.includes(eventsLocation);
  const hideExtendedPaths = [orderLocation, payLocation, bookLocation, loyaltyLocation, preLoginLocation, eventsDetailsLocation, bookEventLocation, kioskLoginLocation];
  const hidePaths = [homeLocation, appLoginLocation, checkoutLocation, pswRecoveryLocation, signupLocation, userDataLocation, receiptLocation, bookEditLocation, "/", ...hideExtendedPaths];
  const showPaths = [bookingDataLocation];
  const goToLoyalty = isSignedIn ? null : () => {
    UIkit.offcanvas("#offcanvas-login-dx").show();
  };
  const isComingFromOrder = !!((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.from);
  useEffect(() => {
    const hideFooter = isComingFromOrder || (hidePaths.includes(location.pathname) || hideExtendedPaths.some(path => location.pathname.includes(path))) && !showPaths.some(path => location.pathname.includes(path));
    setFooterVisible(!hideFooter);
  }, [location.pathname, isComingFromOrder]);
  return isMobile && footer_nav !== null && footer_nav !== void 0 && footer_nav.visible ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "calc(env(safe-area-inset-bottom, 0) * 0.7 + 0.3em) "
    },
    className: "uk-box-shadow-medium uk-position-relative uk-flex uk-flex-between uk-flex-bottom uk-child-width-1-5 uk-position-fixed uk-position-bottom   ".concat(defaultClasses.root)
  }, /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-home",
    isMain: false,
    targetLocation: appHomeLocation,
    isLocationActive: appHomeLocationActive,
    icon: "home_outline",
    text: formatMessage({
      id: "footer.nav.tab.home"
    })
  }), /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-loyalty",
    isMain: false,
    targetLocation: myAreaLocation,
    isLocationActive: myAreaLocationActive,
    override: goToLoyalty,
    icon: "person",
    text: formatMessage({
      id: "footer.nav.tab.loyalty"
    })
  }), /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-order",
    tableData: tableData,
    tableDescription: tableDescription,
    isMain: true,
    targetLocation: orderLocation,
    isLocationActive: orderLocationActive,
    icon: "fork-test",
    text: tableData.cpt && tableData.cps && !payLocationActive ? isTableMapLoaded && tableDescription !== null ? formatMessage({
      id: "TavoloNumber"
    }) + tableDescription : formatMessage({
      id: "TavoloNumber"
    }) + "..." : tableData.cpt && tableData.cps ? formatMessage({
      id: "footer.nav.tab.menu"
    }) : formatMessage({
      id: "footer.nav.tab.order"
    })
  }), store_view_code !== "miscusi_ch_sv" ? /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-book",
    isMain: false,
    targetLocation: bookLocation,
    isLocationActive: bookLocationActive,
    icon: "calendar",
    text: formatMessage({
      id: "footer.nav.tab.booking"
    })
  }) : null, store_view_code !== "miscusi_ch_sv" ? /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-event",
    isMain: false,
    targetLocation: eventsLocation,
    isLocationActive: eventsLocationActive,
    icon: "people",
    text: formatMessage({
      id: "footer.nav.tab.event"
    })
  }) : null) : null;
};
export default FooterNav;